/* Action constants */
export const UNDO_HIDE = 'hide';
export const UNDO_SHOW = 'show';

/* Undo state reducer initial state */
export const initialState = {
  show: false,
  product: null
};

/**
 * Allows a product to be re-added back to the cart
 * @param {object} state - state for all filter options
 * @param {boolean} state.show - `true` if the undo state should be displayed
 * @param {object} state.product - information of product to restore
 * @param {object} action - describes the type of action and associated data
 * @param {string} action.type - the type of action to be performed
 * @param {object} action.product - information of product to restore
 */
export const undoStateReducer = (state, action) => {
  switch (action.type) {
    default:
    case UNDO_HIDE:
      return { show: false, product: state.product };
    case UNDO_SHOW:
      return { show: true, product: action.product };
  }
};
